import React from 'react';
import PropTypes from 'prop-types';

import SimpleProductConfigurationHeader from '../SimpleProductConfigurationHeader';
import ProductConfigurationHeader from '../ProductConfigurationHeader';
import NutritionalLabels from '../NutritionalLabels/NutritionalLabels';

function Header({ product, onClose, withOverlay, nutritionInfo, isQC }) {
  const { image } = product;

  return image ? (
    <ProductConfigurationHeader
      onClose={onClose}
      withOverlay={withOverlay}
      product={product}
      isQC={isQC}
    >
      {nutritionInfo && <NutritionalLabels nutritionInfo={nutritionInfo} />}
    </ProductConfigurationHeader>
  ) : (
    <SimpleProductConfigurationHeader product={product} onClose={onClose} />
  );
}

Header.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    price: PropTypes.number,
    priceWithDiscount: PropTypes.number,
    subsidizedProduct: PropTypes.object,
    hasCustomPhoto: PropTypes.bool,
    isFavourite: PropTypes.bool,
    itemId: PropTypes.string,
  }).isRequired,
  nutritionInfo: PropTypes.object,
  onClose: PropTypes.func,
  withOverlay: PropTypes.bool,
  isQC: PropTypes.bool,
};

export default Header;
